export default __webpack_public_path__ + "static/media/ThingsThatSting_00.522ad11c.png";